export async function myGetJson(url){
    let res = await fetch(url,{
        method:"GET",
        credentials: "omit"
    })
    return res.json();
}

export async function myGet(url){
    return await fetch(url, {
        method: "GET",
        credentials: "omit"
    });
}

export async function myPost(url, data){
    const response = await fetch(url,{
        method:"POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: "omit"
    });
    return response.json();
}